import React, { useState, useEffect, createContext } from 'react';
import CommonDashboardCard from '../../components/PartnerDashboardCard/CommonDashboardCard';
const lead_icon = '/images/icons/lead_icon.svg';
const sanction_icon = '/images/icons/sanction_icon.svg';
const disbursement_icon = '/images/icons/disbursement_icon.svg';
const login_icon = '/images/icons/login_icon.svg';
const plusIcon = '/images/icons/plus.svg';
import moment from 'moment';
import Header from '../../common/components/Header/Header';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../data/SiteConfig';
import Table from '../../components/Table/LemsTable';
import Columns from '../../components/Table/BPColumData';
import './PartnerDashboard.css';
import TimeFilterWrapper from '../../components/TimeFilterWrapper/TimeFilterWrapper';
import {
  getBPCardsData,
  getPBTableDataBP,
  serachCustomer
} from '../../common/constants/api';
import { getFiltersInfo, setFiltersInfo } from '../../common/utils/FiltersInfo';
import { navigate } from 'gatsby';
import { GetLeadStatus } from '../../common/constants/api';
import CircularProgress from '@material-ui/core/CircularProgress';
import FloatingOptions from '../../common/components/FloatingOptions/FloatingOptions';
import { addButton as AddButton } from '../../common/components/FloatingButtons/FloatingButtons';

let icons = [
  { icon: lead_icon },
  { icon: login_icon },
  { icon: sanction_icon },
  { icon: disbursement_icon }
];
let cardStaticData = [
  {
    amount: 0,
    count: 0,
    payout: 0,
    status: 'New Lead'
  },
  {
    amount: 0,
    count: 0,
    payout: 0,
    status: 'Login'
  },
  {
    amount: 0,
    count: 0,
    payout: 0,
    status: 'Sanction'
  },
  {
    amount: 0,
    count: 0,
    payout: 0,
    status: 'Disbursement'
  }
];

const StatusOPtion = [
  {
    label: 'LEAD',
    value: 'LEAD'
  },
  {
    label: 'DOC PENDING',
    value: 'DOC PENDING'
  }
];
export const StateExporterPtn = createContext();

const PartnerDashboard = () => {
  const [TableData, setTableData] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const url = new URL(window.location.href);
  const getStatus = () =>
    url.searchParams.get('status') || getFiltersInfo().status || '';
  const [FilterStatus, setFilterStatus] = useState(getStatus());
  const [tableInfo, setTableInfo] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [cardLoading, setCardLoading] = useState(true);
  const [show, setShow] = useState(false);

  const [filterProductType, setFilterProductType] = useState(
    getFiltersInfo()?.productType || ''
  );
  const productIdSetter = filterProductType => {
    if (filterProductType === 'Home Loan')
      return setFilterProductId ? setFilterProductId(1) : 1;
    if (filterProductType === 'LAP')
      return setFilterProductId ? setFilterProductId(2) : 2;
    if (filterProductType === 'PL')
      return setFilterProductId ? setFilterProductId(13) : 13;
  };
  const [filterProductId, setFilterProductId] = useState(
    productIdSetter(getFiltersInfo()?.productType) || ''
  );
  useEffect(() => {
    if (filterProductType) {
      productIdSetter(filterProductType);
    } else setFilterProductId('');
  }, [filterProductType]);
  const onButtonClickHandler = () => {
    setShow(!show);
  };

  useEffect(() => {
    setCardLoading(true);
    let copyCardStaticData = [...cardStaticData];
    getBPCardsData(startDate, endDate)
      .then(res => {
        res.map((item, index) => {
          const finalDefaultData = copyCardStaticData[index]
            ? copyCardStaticData[index]
            : {};
          const getRidOfNullItems = Object.keys(item).filter(
            each => item[each] !== null
          );

          const objeAfterGettingRidOfNullItems = getRidOfNullItems.reduce(
            (acc, key) => {
              acc[key] = item[key];
              return acc;
            },
            {}
          );
          copyCardStaticData[index] = {
            ...finalDefaultData,
            ...objeAfterGettingRidOfNullItems
          };
        });
        setCardData(copyCardStaticData);
        setCardLoading(false);
      })
      .catch(err => {});
  }, [startDate, endDate]);

  useEffect(() => {
    setTableLoading(true);
    getPBTableDataBP(
      0,
      10,
      startDate,
      endDate,
      'createdOn',
      'desc',
      FilterStatus,
      filterProductId
    )
      .then(data => {
        setTableData(data.data);
        setTableInfo(data.dataPage);
        setTableLoading(false);
      })
      .catch(err => {});
  }, [startDate, endDate]);

  return (
    <React.Fragment>
      <Helmet title={`Dashboard Business Partner | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />
          {show ? (
            <FloatingOptions rm={false} show clicked={onButtonClickHandler} />
          ) : (
            <AddButton clicked={onButtonClickHandler} />
          )}
          <div className="widhtMd max-screen flex-1 w-full ">
            <Header />
            <div className="flex flex-row flex-wrap justify-between mt-2 ml-6">
              <StateExporterPtn.Provider
                value={{
                  startDate,
                  setStartDate,
                  endDate,
                  setEndDate
                }}
              >
                <TimeFilterWrapper />
              </StateExporterPtn.Provider>
              <div
                onClick={() => {
                  navigate('/app/addlead');
                }}
                className=" w-48 h-12 mr-7 mt-2 cursor-pointer text-center text-white bg-tealCol-100 rounded-md hidden md:block"
              >
                <div className="mx-auto inline-flex  ">
                  <img className="block mr-3" src={plusIcon} alt="" />
                  <span className="text-base py-3 block">Add Lead</span>
                </div>
              </div>
            </div>
            {!cardLoading ? (
              <div className="test w-full ">
                <div className="cardsContainer">
                  {cardData.length !== 0 &&
                    cardData.map((each, index) => {
                      return (
                        <CommonDashboardCard
                          key={index}
                          sendeach={each}
                          icons={icons[index]}
                        />
                      );
                    })}

                  {!cardData ||
                    (cardData && cardData.length === 0 && (
                      <p className="text-red-300">Something went wrong</p>
                    ))}
                </div>
              </div>
            ) : (
              <div className="w-full mx-auto text-center items-center py-5">
                <CircularProgress />
              </div>
            )}
            <Table
              itsBp
              setFilterStatus={setFilterStatus}
              StatusFilter=""
              Search=""
              data={TableData ? TableData : []}
              StatusOPtion={StatusOPtion ? StatusOPtion : []}
              columns={Columns}
              serverPagination
              serverPaginationUrl={getPBTableDataBP}
              searchUrl={serachCustomer}
              TableInfo={tableInfo}
              startDate={startDate}
              endDate={endDate}
              tableLoading={tableLoading}
              filterName="status"
              searchName="leadId"
              serchBarPlaceHolder="Search by name, Lead ID or Mobile No"
              GetLeadStatus={GetLeadStatus}
              filterImage={false}
              filterCaption="Status"
              tableListbelongs="Leads"
              filterComponent
              labelText="All"
              serverSort
              filterProductId={filterProductId}
              setFilterProductId={setFilterProductId}
              filterProductType={filterProductType}
              setFilterProductType={setFilterProductType}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PartnerDashboard;
